module.exports = __webpack_public_path__ + "images/emoji/watermelon.1480db00128367d751dd.png";